import {isNil} from 'ramda';

import {Nullish} from '../types/Nullish';

export const BRAND_IMAGE_BASE_URL = '/assets/images/brands';

export const MAKE_TO_FILENAME: Record<string, string> = {
  MAKE_AUDI: 'audi.png',
  MAKE_BMW: 'bmw.png',
  MAKE_CITROEN: 'citroen.png',
  MAKE_DACIA: 'dacia.png',
  MAKE_FIAT: 'fiat.png',
  MAKE_FORD: 'ford.png',
  MAKE_HYUNDAI: 'hyundai.png',
  MAKE_KIA: 'kia.png',
  MAKE_MERCEDES_BENZ: 'mercedes_benz.png',
  MAKE_PEUGEOT: 'peugeot.png',
  MAKE_SKODA: 'skoda.png',
  MAKE_VOLKSWAGEN: 'volkswagen.png',
};

const MAKE_PREFIX = 'MAKE_';

/**
 * Normalises both prefixed (`MAKE_HYUNDAI`) and bare (`HYUNDAI`) make keys.
 * Idempotent for already-prefixed keys.
 */
function normaliseMakeKey(makeKey: string): string {
  return makeKey.startsWith(MAKE_PREFIX) ? makeKey : `${MAKE_PREFIX}${makeKey}`;
}

export function getBrandImageUrl(makeKey: string): string | undefined;
export function getBrandImageUrl(makeKey: Nullish): undefined;
export function getBrandImageUrl(makeKey: string | Nullish): string | undefined;
export function getBrandImageUrl(makeKey: string | Nullish): string | undefined {
  if (isNil(makeKey)) {
    return undefined;
  }

  const normalisedKey = normaliseMakeKey(makeKey);
  const hasFilename = Object.prototype.hasOwnProperty.call(MAKE_TO_FILENAME, normalisedKey);

  if (!hasFilename) {
    return undefined;
  }

  const filename = MAKE_TO_FILENAME[normalisedKey];

  if (isNil(filename)) {
    return undefined;
  }

  return `${BRAND_IMAGE_BASE_URL}/${filename}`;
}
